import { Chain, ChainID } from '@ankr.com/chains-list';

import { useAuth } from 'modules/auth/hooks/useAuth';

import { PrivateChainLoader } from './components/PrivateChainLoader';
import { PublicChainPageLoader } from './components/PublicChainLoader';
import { useChainPageLoaderStyles } from './useChainPageLoaderStyles';

interface ChainPageLoaderProps {
  Component: React.FC<{ chain: Chain }>;
  chainID: ChainID;
}

export const ChainPageLoader = ({
  Component,
  chainID,
}: ChainPageLoaderProps) => {
  const { isLoggedIn } = useAuth();

  const { classes } = useChainPageLoaderStyles();

  const ChainLoader = isLoggedIn ? PrivateChainLoader : PublicChainPageLoader;

  return (
    <div className={classes.root}>
      <ChainLoader Component={Component} chainID={chainID} />
    </div>
  );
};
